module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00013-fs8.12fc79f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00013-fs8.png
// module id = 166
// module chunks = 0